/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Accessible_TitleInputs */

const en_a11y_statement_accessible_title = /** @type {(inputs: A11y_Statement_Accessible_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accessible Areas`)
};

const de_a11y_statement_accessible_title = /** @type {(inputs: A11y_Statement_Accessible_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barrierefreie Bereiche`)
};

const fr_a11y_statement_accessible_title = /** @type {(inputs: A11y_Statement_Accessible_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zones accessibles`)
};

const es_a11y_statement_accessible_title = /** @type {(inputs: A11y_Statement_Accessible_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Areas accesibles`)
};

const it_a11y_statement_accessible_title = /** @type {(inputs: A11y_Statement_Accessible_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aree accessibili`)
};

const nl_a11y_statement_accessible_title = /** @type {(inputs: A11y_Statement_Accessible_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toegankelijke gebieden`)
};

const pl_a11y_statement_accessible_title = /** @type {(inputs: A11y_Statement_Accessible_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostepne obszary`)
};

const fi_a11y_statement_accessible_title = /** @type {(inputs: A11y_Statement_Accessible_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saavutettavat alueet`)
};

const da_a11y_statement_accessible_title = /** @type {(inputs: A11y_Statement_Accessible_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilgaengelige omrader`)
};

const sv_a11y_statement_accessible_title = /** @type {(inputs: A11y_Statement_Accessible_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tillgangliga omraden`)
};

/**
* | output |
* | --- |
* | "Accessible Areas" |
*
* @param {A11y_Statement_Accessible_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_accessible_title = /** @type {((inputs?: A11y_Statement_Accessible_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Accessible_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_accessible_title(inputs)
	if (locale === "fr") return fr_a11y_statement_accessible_title(inputs)
	if (locale === "es") return es_a11y_statement_accessible_title(inputs)
	if (locale === "it") return it_a11y_statement_accessible_title(inputs)
	if (locale === "nl") return nl_a11y_statement_accessible_title(inputs)
	if (locale === "pl") return pl_a11y_statement_accessible_title(inputs)
	if (locale === "fi") return fi_a11y_statement_accessible_title(inputs)
	if (locale === "da") return da_a11y_statement_accessible_title(inputs)
	if (locale === "sv") return sv_a11y_statement_accessible_title(inputs)
	return en_a11y_statement_accessible_title(inputs)
});